/** @format */

import React from "react";
import { QueryProps } from "../../resourceIndexUI/ResourcesIndexUI";
import { AllParams } from "../ResourcesFilter";
import { ReactComponent as Circle } from "bootstrap-icons/icons/circle.svg";
import { ReactComponent as CheckCircle } from "bootstrap-icons/icons/check-circle-fill.svg";
import { useTranslation } from "react-i18next";
import { filterResources } from "../utils";
import { ResourceReference } from "../../../../types";

type Props = {
  isLoading?: boolean;
  query: QueryProps;
  allParams: AllParams;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  resources: ResourceReference[] | undefined;
};

const LevelFilter: React.FC<Props> = ({
  isLoading,
  query,
  allParams,
  handleQueryItemClick,
  resources,
}) => {
  const { t: _ } = useTranslation();

  let allLevels = resources
    ? [...allParams.level].map((t) => {
        const count = filterResources([...resources], "level", query).filter(
          (r) =>
            Array.isArray(r.Object.levels) && r.Object.levels.includes(t.title),
        ).length;
        if (count !== t.count) {
          return { ...t, count: count };
        }
        return t;
      })
    : [...allParams.level];

  return (
    <>
      {(!!allLevels?.length || isLoading) && (
        <div className="card shadow mb-3">
          <div className="card-body" key="level-filter">
            <h5>{_("Exam Level")}</h5>

            {isLoading &&
              [1, 2, 3].map((i) => (
                <button
                  key={`level${i}`}
                  className={`w-100 btn btn-light text-start py-0 mb-2`}
                >
                  <Circle />
                  &emsp;<span className="placeholder col-4"></span>{" "}
                  <span className="float-end placeholder col-1"></span>
                </button>
              ))}

            {allLevels
              ?.sort((a, b) => (a.title < b.title ? -1 : 1))
              .map((_level) => (
                <button
                  key={_level.title}
                  onClick={() => handleQueryItemClick(_level.title, "level")}
                  className={`w-100 btn btn-light text-start py-0 mb-2`}
                >
                  {_level.title === query.level ? <CheckCircle /> : <Circle />}
                  &emsp;
                  {_(_level.title)}{" "}
                  <span className="float-end text-muted">{_level.count}</span>
                </button>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default LevelFilter;
